import { authenticationService } from '../services';
import axios from 'axios';
import AppConstants from '../common/AppConstants';
import Helper from '../common/Helper';

export function curriculumAuthHeader(type) {
    // return authorization header with jwt token
    // const currentUser = authenticationService.currentUserValue;

    // if ((currentUser && currentUser.token)) {
    //     return { Authorization: `Bearer ${currentUser?.curriculumToken}` };
    // } else {
    //     return {};
    // }
// Get the request token (you might need to call an endpoint to get this)
    //let requestToken = response.headers['X-CURR-Request-Token'];
    let requestToken = Helper.getCookie('CURRICULUM-REQUEST-TOKEN');
    

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    //let token = Helper.getCookie('CURRICULUM-XSRF-TOKEN');

    if (type) {
        return { 'Content-Type': type, cancelToken: source.token, 'X-CURRICULUM-XSRF-TOKEN': requestToken };
    } else {
        return { 'Content-Type': AppConstants.HeaderTypes.APPLICATION_JSON, cancelToken: source.token, 'X-CURRICULUM-XSRF-TOKEN': requestToken};
    }
}

// export function authHeader() {
//     // return authorization header with jwt token
//     const accessToken = localStorage.getItem("accessToken");
//     if (accessToken && accessToken !== "") {
//         //let accssTokenString = JSON.parse(JSON.stringify(accessToken)); //.replace(/"/g, "");
//         return { Authorization: "Bearer " + accessToken };
//     } else {
//         return {};
//     }
// }